import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { OCmsHeader, OCmsAside, OCmsFooter } from '../components/organisme';
import { logOut } from '../redux/cms/cmsActions';
import withAuthGuard from '../helpers/withAuthGuard';

const mapStateToProps = state => ({
	title: state.head.cms.title,
	description: state.head.cms.description,
	buttonName: state.head.cms.buttonName,
	onClick: state.head.cms.onClick,
});

class CmsTemplatePage extends React.Component {
	constructor(props) {
		super(props);
		this.bindHandles();
	}

	bindHandles() {
		this.handleLogOut = this.handleLogOut.bind(this);
	}

	handleLogOut() {
		this.props.logOut();
		this.props.history.go('/cms/login');
	}

	render() {
		return (
			<div className="layout-cms">
				<OCmsHeader {...this.props} />
				<main className="layout-cms--body">
					<OCmsAside
						logOut={this.handleLogOut}
					/>
					{this.props.children}
				</main>
				<OCmsFooter />
			</div>
		);
	}
}

CmsTemplatePage.propTypes = {
	children: PropTypes.any.isRequired,
	logOut: PropTypes.func.isRequired,
};

export default withAuthGuard(withRouter(connect(mapStateToProps, {
	logOut,
})(CmsTemplatePage)));



// WEBPACK FOOTER //
// ./src/CMS/cms-template.page.js